<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row dense justify="center">
      <!-- user: {{ usertype }} -->
      <v-radio-group v-model="usertype" mandatory row class="ma-2 no-display">
        <v-radio label="Student" value="Student" color="#0f2027"></v-radio>
        <v-radio label="Parent" value="Parent" color="#0f2027"></v-radio>
        <v-radio label="Employee" value="Employee" color="#0f2027"></v-radio>
      </v-radio-group>
    </v-row>
    <template v-if="show_card">
      <template v-if="load == true">

        <div style="width: 700px;margin: auto auto">
          <v-card class="box">
            <v-card-title class="toolbar">
              <span class="headline">Add Roles to {{ usertype }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" md="9">
                    <v-autocomplete rounded outlined dense v-model="seluser" :items="users" return-object
                      item-text="name" label="Select User" prepend-icon="mdi-account" />

                  </v-col>
                  <v-col cols="12" md="3">
                    <v-chip v-if="seluser.usertype">
                      <v-icon left color="green">mdi-account</v-icon>
                      {{ seluser.usertype }}
                    </v-chip>

                  </v-col>
                  <v-col cols="12" md="12">
                    <v-autocomplete rounded outlined dense :items="modules" v-model="selmodule" label="Select Modules"
                      persistent-hint prepend-icon="mdi-menu" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <div v-if="roles.length > 0">
                      <b> Roles for {{ selmodule }} </b>
                      <v-checkbox v-for="role in roles" :key="role.id" v-model="addrole" :label="role.name"
                        :value="role.id" color="success"></v-checkbox>
                      <span v-if="addrole.length == 0">
                        <v-chip>
                          <v-icon left color="red">mdi-exclamation-thick</v-icon>
                          Please select roles
                        </v-chip>
                      </span>
                    </div>

                    <v-btn :disabled="addrole.length < 1" class="mb-2 button" @click="addRoleToUser">Add Roles </v-btn>

                  </v-col>

                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </div>
        <br>
        <v-simple-table class="elevation-1 mytable" dense v-if="curr_roles.length > 0">
          <template v-slot:default>
            <caption class="headline toolbar">Roles of {{ seluser.username }}</caption>

            <thead>
              <tr>
                <td colspan="3" align="right">
                  <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
                    style="width: 40%"></v-text-field>
                </td>
              </tr>
              <br>
              <tr>
                <th class="text-left">Role</th>
                <th class="text-left">Module</th>
                <th class="text-left">Created By</th>
                <th class="text-left">Created On</th>
                <th class="text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in tablerolefilterdata" :key="item.id">
                <td>{{ item.role }}</td>
                <td>{{ item.module }}</td>
                <td>{{ item.creation_username }}</td>
                <td>{{ item.creation_date }}</td>
                <td>
                  <div>
                    <v-avatar style="" size="25" class="delete-avatar">
                      <v-icon class="mr-2 delete-v-icon" @click="deleteRoleToUser(item.userid, item.roleid)"
                        title="Delete role">delete</v-icon>
                    </v-avatar>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <br>
      </template>
      <template v-if="load == false">

        <center>
          <h3>Fetching users. Please wait....
            <v-progress-linear style="width:25%" rounded indeterminate color="blue" class="mb-0"></v-progress-linear>
          </h3>
        </center>
      </template>
    </template>
  </div>
</template>

<script>
import axios from 'axios'

import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      snackbar_msg: "",
      // extraBreadcrumbItems: [
  

      // ],
      // breadcrumbClass: "breadcrumb-style1",
      color: "",
      snackbar: false,
      search: '',
      load: false,
      seluser: {
        username: '',
        usertype: ''
      },
      addrole: [],
      seluser_usertype: '',
      selmodule: '',
      users: [],
      modules: [],
      roles: {},
      curr_roles: {},
      usertype: "", isallowed: false, show_card: false,
    }
  },
  mounted() {

  },
  watch: {
    usertype() {
      //alert(this.usertype)
      this.getUsers()
    },
    seluser() {
      this.getroles()
      //this.seluser_usertype = this.users[this.seluser]
    },
    selmodule() {
      this.getroles()
    },
  },
  methods: {
    getUsers() {
      const formData = {
        ut: this.usertype
      }
      this.load = false
      axios
        .post("/roleManagement/roletouser", formData)
        .then(res => {
          if (res.data.flag == "YES") {
            this.isallowed = res.data.isallowed
            this.users = res.data.users
            this.modules = res.data.modules
            this.load = true
            this.show_card = true
          }
          else if (res.data.flag == "No") {
            this.isallowed = res.data.isallowed
            this.showSnackbar("red", res.data.snackbar)
            this.load = true
            this.show_card = false
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    deleteRoleToUser(userid, roleid) {
      //alert(userid+" "+roleid)
      const req_data = {
        userid: userid,
        roleid: roleid
      }
      axios
        .post("/roleManagement/removenewroletouser", req_data)
        .then(res => {
          if (res.data.msg == "200") {
            this.addrole = [];
            this.getroles()
            this.showSnackbar(
              "#4caf50",
              "User Role Updated Successfully..."
            ); // show snackbar on success
          }
          else {
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    addRoleToUser() {
      //alert("addRoleToUser"+this.addrole+" "+this.seluser)
      const req_data = {
        username: this.seluser.username,
        roleid: this.addrole
      }
      axios
        .post("/roleManagement/addNewRolesToUserWithLogin", req_data)
        .then(res => {
          if (res.data.msg == "200") {
            this.addrole = [];
            this.getroles()
            this.showSnackbar(
              "#4caf50",
              "New Role Added Successfully..."
            ); // show snackbar on success
          }
          else {
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    getroles() {
      if ((this.seluser.username != '') && (this.selmodule != '')) {
        // alert(this.seluser.username)
        const req_data = {
          username: this.seluser.username,
          module: this.selmodule
        }
        axios
          .post("/roleManagement/getroles", req_data)
          .then(res => {
            if (res.data.msg == "200") {
              this.roles = res.data.roles
              this.curr_roles = res.data.curr_roles
            }
            else {
            }
          })
          .catch(error => {
            window.console.log(error);
          });
      }
    }
  },
  computed: {
    tablerolefilterdata() {

      return this.curr_roles.filter(tbdata => {
        return tbdata.role.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
          tbdata.module.toLowerCase().indexOf(this.search.toLowerCase()) >= 0

      })
    }
  }
}
</script>
<style scoped>
.delete-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.delete-avatar:hover {
  background-color: #b0bec5;
}

.delete-v-icon {
  padding-left: 8px;
  padding-top: 1px;
  font-size: 15px;
}

.delete-v-icon:hover {
  color: white;
}
</style>